let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7bjy1")).then(() => parcelRequire('dweXS'));